import React from "react";

interface Props {}
const EditItemDataIframe = (props: Props) => {
  const {} = props;
  return (
    <div>
      {" "}
      <iframe
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        // src={`https://ui.shadcn.com/`}
        src={`https://app.stage-unicorn.win/mars/v2/941/collections/9dae66f8-1992-4eb4-b5fb-12e77d13ec82/items/008c7452-f4e9-4186-bf20-41044b45281f/edit/`}
      ></iframe>
    </div>
  );
};

export default EditItemDataIframe;
